function buildCss(c, headingFont, bodyFont) {
  return `
.lb { font-family: ${bodyFont}; background: #fff; width: 100%; color: #111; }

/* NAV */
.lb-nav {
  padding: 22px 64px; background: #fff;
  display: flex; justify-content: space-between; align-items: center;
}
.lb-nav-logo { font-size: 14px; font-weight: 400; letter-spacing: 0.18em; color: #111; font-family: ${bodyFont}; }
.lb-nav-links { display: flex; gap: 36px; }
.lb-nav-link { font-size: 11px; color: #888; letter-spacing: 0.22em; text-transform: uppercase; cursor: pointer; transition: color 0.2s; font-family: ${bodyFont}; }
.lb-nav-link:hover { color: #111; }
.lb-nav-btn {
  padding: 10px 24px; background: #111; color: #fff; border: none;
  font-size: 11px; letter-spacing: 0.15em; text-transform: uppercase;
  cursor: pointer; font-family: ${bodyFont}; transition: background 0.2s;
}
.lb-nav-btn:hover { background: #333; }

/* HERO */
.lb-hero-img-wrap { position: relative; height: 90vh; overflow: hidden; background: #e8e8e8; }
.lb-hero-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; }
.lb-hero-text { padding: 56px 64px 64px; }
.lb-hero-sub { font-size: 11px; color: #888; letter-spacing: 0.24em; text-transform: uppercase; margin-bottom: 22px; font-family: ${bodyFont}; }
.lb-hero-h1 {
  font-family: ${headingFont};
  font-size: 62px; font-weight: 500; color: #111; line-height: 1.2;
  margin-bottom: 44px; letter-spacing: 0.02em;
}
.lb-hero-rule { width: 100%; height: 1px; background: #ddd; }

/* CONCEPT */
.lb-concept { padding: 120px 64px; text-align: center; }
.lb-concept-label { font-size: 11px; color: #888; letter-spacing: 0.32em; text-transform: uppercase; margin-bottom: 28px; font-family: ${bodyFont}; }
.lb-concept-h2 {
  font-family: ${headingFont};
  font-size: 44px; font-weight: 500; color: #111; line-height: 1.5;
  margin-bottom: 32px; letter-spacing: 0.03em;
}
.lb-concept-desc { font-size: 15px; color: #888; line-height: 2; max-width: 600px; margin: 0 auto; font-weight: 300; font-family: ${bodyFont}; }

/* PHOTO GRID */
.lb-photos-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 3px; }
.lb-photo-item { position: relative; overflow: hidden; height: 380px; background-color: #f5f5f5; }
.lb-photo-img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; object-position: center; display: block; transition: transform 0.6s ease; }
.lb-photo-item:hover .lb-photo-img { transform: scale(1.03); }

/* FEATURES */
.lb-features { padding: 100px 64px; }
.lb-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 48px; }
.lb-feature { border-top: 1px solid #eee; padding-top: 28px; }
.lb-feature-num { font-size: 11px; color: #ccc; letter-spacing: 0.15em; margin-bottom: 16px; font-family: ${bodyFont}; }
.lb-feature-title {
  font-family: ${headingFont};
  font-size: 22px; font-weight: 500; color: #111; margin-bottom: 14px; line-height: 1.4;
}
.lb-feature-desc { font-size: 14px; color: #888; line-height: 1.9; font-weight: 300; font-family: ${bodyFont}; }

/* PRICING */
.lb-pricing { padding: 80px 64px; background: #f9f9f9; }
.lb-pricing-label { font-size: 11px; color: #888; letter-spacing: 0.32em; text-transform: uppercase; text-align: center; margin-bottom: 48px; font-family: ${bodyFont}; }
.lb-pricing-inner { max-width: 560px; margin: 0 auto; }
.lb-pricing-row {
  display: flex; justify-content: space-between; align-items: center;
  padding: 20px 0; border-bottom: 1px solid #eee;
}
.lb-pricing-row:first-child { border-top: 1px solid #eee; }
.lb-pricing-name { font-size: 15px; color: #111; font-family: ${bodyFont}; }
.lb-pricing-price { font-size: 15px; color: ${c}; font-weight: 500; letter-spacing: 0.03em; font-family: ${bodyFont}; }

/* INFO */
.lb-info { padding: 80px 64px; display: grid; grid-template-columns: 1fr 1fr; gap: 80px; }
.lb-info-label { font-size: 11px; color: #888; letter-spacing: 0.3em; text-transform: uppercase; margin-bottom: 22px; font-family: ${bodyFont}; }
.lb-info-value { font-size: 16px; color: #111; line-height: 1.8; margin-bottom: 8px; font-family: ${bodyFont}; }
.lb-info-sub { font-size: 14px; color: #aaa; line-height: 1.8; font-family: ${bodyFont}; }
.lb-map {
  margin-top: 24px; height: 180px; background: #f0f0f0;
  border-radius: 2px; overflow: hidden; position: relative;
  background-image:
    linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px);
  background-size: 32px 32px;
  display: flex; align-items: center; justify-content: center;
}
.lb-map::before {
  content: ''; position: absolute; top: 50%; left: 0; right: 0;
  height: 1px; background: rgba(0,0,0,0.1); transform: translateY(-50%) rotate(-4deg);
}
.lb-map::after {
  content: ''; position: absolute; top: 20%; bottom: 0; left: 48%;
  width: 1px; background: rgba(0,0,0,0.08);
}
.lb-map-pin { font-size: 30px; position: relative; z-index: 1; }

/* CTA */
.lb-cta { padding: 100px 64px; background: #111; text-align: center; }
.lb-cta-h2 {
  font-family: ${headingFont};
  font-size: 44px; font-weight: 500; color: #fff; margin-bottom: 20px; line-height: 1.35;
}
.lb-cta-sub { font-size: 15px; color: rgba(255,255,255,0.45); margin-bottom: 48px; font-weight: 300; font-family: ${bodyFont}; }
.lb-cta-btn {
  display: inline-block; padding: 16px 60px;
  border: 1px solid rgba(255,255,255,0.45); color: #fff; background: transparent;
  font-size: 11px; letter-spacing: 0.2em; text-transform: uppercase;
  cursor: pointer; font-family: ${bodyFont}; transition: background 0.3s, border-color 0.3s;
}
.lb-cta-btn:hover { background: rgba(255,255,255,0.08); border-color: #fff; }

/* FOOTER */
.lb-footer {
  padding: 28px 64px; background: #111;
  display: flex; justify-content: space-between; align-items: center;
  border-top: 1px solid rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.28); font-size: 12px; letter-spacing: 0.06em;
  font-family: ${bodyFont};
}

/* MOBILE */
@media (max-width: 768px) {
  .lb-nav { padding: 18px 20px; }
  .lb-nav-links { display: none; }
  .lb-hero-img-wrap { height: 60vh; }
  .lb-hero-text { padding: 32px 20px 40px; }
  .lb-hero-h1 { font-size: 36px; }
  .lb-concept { padding: 72px 20px; }
  .lb-concept-h2 { font-size: 30px; }
  .lb-photos-grid { grid-template-columns: 1fr; }
  .lb-photo-item { height: 260px; }
  .lb-features { padding: 64px 20px; }
  .lb-features-grid { grid-template-columns: 1fr; gap: 32px; }
  .lb-pricing { padding: 56px 20px; }
  .lb-info { grid-template-columns: 1fr; padding: 56px 20px; gap: 48px; }
  .lb-cta { padding: 72px 20px; }
  .lb-cta-h2 { font-size: 30px; }
  .lb-footer { padding: 24px 20px; flex-direction: column; gap: 8px; text-align: center; }
}
`;
}

const DEFAULT_HEADING = "'Shippori Mincho', serif";
const DEFAULT_BODY    = "'DM Sans', system-ui, sans-serif";

export default function LocalBusiness({ data, fontSet }) {
  const c           = data.color || '#c9a96e';
  const headingFont = fontSet?.heading || DEFAULT_HEADING;
  const bodyFont    = fontSet?.body    || DEFAULT_BODY;

  return (
    <>
      <style>{buildCss(c, headingFont, bodyFont)}</style>
      <div className="lb">

        {/* NAV */}
        <nav className="lb-nav">
          <span className="lb-nav-logo">{data.siteName}</span>
          <div className="lb-nav-links">
            {['ABOUT', 'MENU', 'ACCESS', 'RESERVE'].map(item => (
              <span key={item} className="lb-nav-link">{item}</span>
            ))}
          </div>
          <button className="lb-nav-btn">{data.cta}</button>
        </nav>

        {/* HERO */}
        <div className="lb-hero-img-wrap">
          <img src={data.heroImage} alt="" className="lb-hero-img" />
        </div>
        <div className="lb-hero-text">
          <p className="lb-hero-sub">{data.industry}</p>
          <h1 className="lb-hero-h1">{data.heroHeading}</h1>
          <div className="lb-hero-rule" />
        </div>

        {/* CONCEPT */}
        <div className="lb-concept">
          <p className="lb-concept-label">CONCEPT</p>
          <h2 className="lb-concept-h2">{data.tagline}</h2>
          <p className="lb-concept-desc">{data.description}</p>
        </div>

        {/* PHOTO GRID */}
        {data.images && data.images.length > 0 && (
          <div className="lb-photos">
            <div className="lb-photos-grid">
              {data.images.slice(0, 3).map((img, i) => (
                <div key={i} className="lb-photo-item">
                  <img src={img} alt="" className="lb-photo-img" />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* FEATURES */}
        <div className="lb-features">
          <div className="lb-features-grid">
            {data.features.map((f, i) => (
              <div key={i} className="lb-feature">
                <p className="lb-feature-num">0{i + 1}</p>
                <h3 className="lb-feature-title">{f.title}</h3>
                <p className="lb-feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* PRICING */}
        {data.plans && data.plans.length > 0 && (
          <div className="lb-pricing">
            <p className="lb-pricing-label">PLAN & PRICE</p>
            <div className="lb-pricing-inner">
              {data.plans.map((p, i) => (
                <div key={i} className="lb-pricing-row">
                  <span className="lb-pricing-name">{p.name}</span>
                  <span className="lb-pricing-price">{p.price}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* HOURS & ACCESS */}
        <div className="lb-info">
          <div>
            <p className="lb-info-label">HOURS</p>
            <p className="lb-info-value">{data.hours || '平日 10:00 – 20:00'}</p>
            <p className="lb-info-sub">土日祝・定休</p>
          </div>
          <div>
            <p className="lb-info-label">ACCESS</p>
            <p className="lb-info-value">{data.address || '東京都'}</p>
            <div className="lb-map">
              <span className="lb-map-pin">📍</span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="lb-cta">
          <h2 className="lb-cta-h2">{data.heroHeading}</h2>
          <p className="lb-cta-sub">{data.tagline}</p>
          <button className="lb-cta-btn">{data.cta}</button>
        </div>

        {/* FOOTER */}
        <footer className="lb-footer">
          <span>{data.siteName}</span>
          <span>© 2025 {data.siteName}. All rights reserved.</span>
        </footer>

      </div>
    </>
  );
}
